// biome-ignore lint/style/noRestrictedImports: encapsulation
import type { PostHog } from "posthog-js";
// biome-ignore lint/style/noRestrictedImports: encapsulation
import { usePostHog as _usePostHog } from "posthog-js/react";

/**
 * PostHog instance might be undefined during the initial render.
 * Enforce it with type assertion.
 *
 * @see https://posthog.com/docs/libraries/react#typeerror-cannot-read-properties-of-undefined
 */
export const usePostHog: () => undefined | PostHog = _usePostHog;
